import {PinterestLazy} from 'app/components/multimedia/gallery/pinterest/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

import {shouldSkipLazyLoad} from './shouldSkipLazyLoad';

export function defineMultimediaPinterest(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-multimedia-pinterest')) {
        return;
    }

    customElements.define(
        'gem-multimedia-pinterest',
        class extends WebComponentLoader {
            reactLazyComponent = PinterestLazy;
            shouldSkipLazyLoad = shouldSkipLazyLoad;
        },
    );
}
